var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('div',{style:({ position: 'relative' })},[_c(_setup.Table,{attrs:{"headers":[
          {
            text: 'Application Type',
            value: 'is_renewal',
            fn: (house) => house.is_renewal == '1' ? 'Renewal' : 'Initial Application'

          },

          {
            text: 'Application Number',
            value: 'approval_number',
            fn: (house) => house.building.approval_number

          },

          {
            text: 'Customer Name',
            value: 'is_renewal',
            fn: (house) => house.building.building_owner.length > 0 ? house.building.building_owner[0].clients.customer_name : ' '

          },

          {
            text: 'Architect Name',
            value: 'building_architect',
            fn: (house) => house.building.building_architect.length > 0 ? house.building.building_architect[0].architects.first_name + ' ' + house.building.building_architect[0].architects.last_name : ' ',

          },

          {
            text: 'Type Of Development',
            value: 'type_of_development',
            fn: (house) => house.building.building_development_type.type_of_development,
            
          },

          {
            text: 'Application Date',
            value: 'is_renewal',
            fn: (house) => _setup.getFormattedBillDate(house.valid_from)

          },

          {
            text: 'Expiration Date',
            value: 'valid_to',
            fn: (house) => _setup.getFormattedBillDate(house.valid_to)

          },

          {
            text: 'Building Status',
            value: 'is_renewal',
            fn: (house) => house.building.status.status

          },

          {
            text: 'Application Status',
            value: 'status',
            fn: (house) => house.workflow_status.status_name
          },

          {
            text: 'Actions',
            value: 'view',
            action: true,
            fn: (house) => house.workflow_status.status_name
          },


          // { text: 'Pay', value: 'is_renewal', action: true },
        ],"items":_vm.buildings,"loading":_vm.loading,"emptyText":"No Buildings Found","headClasses":"primary white--text"},scopedSlots:_vm._u([{key:"item.view",fn:function({ item }){return [_c('div',{staticStyle:{"min-width":"85px"}},[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-btn',_vm._g(_vm._b({staticClass:"button mr-1 primary--text",attrs:{"icon":""},on:{"click":function($event){return _vm.$emit('viewBuilding', item)}}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"small":""}},[_vm._v(" mdi-eye ")])],1)]}}],null,true)},[_c('span',[_vm._v(_vm._s(_vm.$t("viewMsg")))])]),(item.building_application_bill.bills.bills_invoices[0].invoice_receipt)?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-btn',_vm._g(_vm._b({staticClass:"button mr-1 success--text",attrs:{"icon":""},on:{"click":function($event){return _setup.onPrintReceipt(item.building_application_bill.bills.bills_invoices[0].invoice_receipt.receipt)}}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"small":""}},[_vm._v(" mdi-printer ")])],1)]}}],null,true)},[_c('span',[_vm._v("Download Receipt")])]):_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-btn',_vm._g(_vm._b({staticClass:"button mr-1 error--text",attrs:{"icon":""},on:{"click":function($event){return _setup.onPrintBillClicked(item.building_application_bill.bills)}}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"small":""}},[_vm._v(" mdi-printer ")])],1)]}}],null,true)},[_c('span',[_vm._v("No Receipt Available, Please Pay for this Bill")])]),(item.building.status.status != 'DEMOLISHED' && item.workflow_status.status_name != 'In Progress')?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-btn',_vm._g(_vm._b({staticClass:"button mr-1 success--text",attrs:{"icon":""},on:{"click":function($event){return _vm.renewBuildingApplication(item)}}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"medium":""}},[_vm._v(" mdi-restart ")])],1)]}}],null,true)},[_c('span',[_vm._v("Renew Building Application")])]):_vm._e(),(item.building_application_bill.bills.bills_invoices[0].invoice_receipt && item.workflow_status.status_name != 'In Progress')?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-btn',_vm._g(_vm._b({staticClass:"button mr-1 success--text",attrs:{"icon":""},on:{"click":function($event){return _vm.$emit('enfBuildApp', item)}}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"small":""}},[_vm._v(" mdi-police-badge ")])],1)]}}],null,true)},[_c('span',[_vm._v("Enforce Building Application")])]):_vm._e(),(item.building_application_bill.bills.bills_invoices[0].invoice_receipt && item.workflow_status.status_name != 'In Progress')?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-btn',_vm._g(_vm._b({staticClass:"button mr-1 success--text",attrs:{"icon":""},on:{"click":function($event){return _vm.$emit('renoOrDemo', item)}}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"small":""}},[_vm._v(" mdi-wrench ")])],1)]}}],null,true)},[_c('span',[_vm._v("Renovate or Demolish Building")])]):_vm._e()],1)]}}])})],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }